// 菜单配置
// 公共菜单
const commonMenuConfig = [
    {
        path: '/',
        name: '首页',
        icon: 'el-icon-s-home',
    },
    // {
    //     path:'/common',
    //     name:'公共模块',
    //     icon:'el-icon-menu',
    //     children:[
    //         {
    //             path: '/notice',
    //             name: '系统通知'
    //         }
    //     ]
    // }
    
]
//管理员菜单
export const adminMenuConfig = commonMenuConfig.concat([
           {
               path: '/recruitment',
               name: '招考信息',
               icon: 'el-icon-menu',
               children: [
                   {
                       path: '/list',
                       name: '招考列表'
                   },
                   {
                       path: '/point',
                       name: '考点维护'
                   }
               ]
           },
           {
               path: '/signup',
               name: '考生管理',
               icon: 'el-icon-date',
               children: [
                   {
                       path: '/list',
                       name: '报考审查'
                   },
                   {
                       path: '/achievement',
                       name: '成绩管理'
                   }
               ]
           }
       ])

export const rootMenuConfig = adminMenuConfig.concat([
    {
        path: '/setting',
        name: '系统设置',
        icon: 'el-icon-setting',
        children: [
            {
                path: '/admin',
                name: '管理员维护'
            }
        ]
    }
])

//考生菜单
export const examineeMenuConfig = commonMenuConfig.concat([
    {
        name: '我的报考',
        icon: 'el-icon-menu',
        path:'/examinee',
        children: [
            {
                path: '/index',
                name: '报考记录'
            },
            {
                path: '/achievement',
                name: '成绩查询'
            }
        ]
    }
])
